import React from 'react';
import { withTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { UserService } from '../../services/UserService';
import useRequest from '../../hooks/useRequest';

import MainLayout from '../../components/Layouts/MainLayout';


import GradientButton from '../../components/atoms/GradientButton';


import './styles.scss';

const UnsubscribeRequestView = (props) => {
    const history = useHistory();

    const {
        submitted, success, message,
        beforeSubmit, afterSubmit, showSuccess, showError,
        dealWithError
    } = useRequest();

    const handleSubmit = (e) => {
        e.preventDefault();
        beforeSubmit();
        console.log('va');
        UserService.unsubscribeRequest()
        .then(data => {
            afterSubmit();
            showSuccess('Se ha enviado un e-mail a su casilla de correo para realizar la baja.');
            history.push('/solicitud_baja_enviada');
        }).catch((error) => {
            dealWithError(error, 'Error al solicitar baja');
        });
    }

    return (
        <MainLayout>
            <div className="unsubscribe-request-container">
                <div className="unsubscribe-request-content">
                    <form className="unsubscribe-request-form" onSubmit={handleSubmit}>
                        <h1 className="unsubscribe-request-title">Solicitar la baja de mi usuario</h1>
                        <h2 className="unsubscribe-request-subtitle">Te enviaremos un correo electrónico para que confirmes la baja de tu usuario de la Oficina Virtual.
                        <br></br>
                            <br></br>
                        No implica la baja de Factura Digital ni Débito Automático.</h2>
                        {(success === false && message) &&
                            <p className="error-messages">{message}</p>
                        }
                        {(success === true && message) &&
                            <p className="success-messages">{message}</p>
                        }
                        <div className="unsubscribe-request-button">
                            <GradientButton legend={'SOLICITAR'} disabled={submitted}
                                handleClick={handleSubmit} type={'submit'} />
                        </div>
                    </form>
                </div>
            </div>
        </MainLayout>
    );
}

export default withTranslation()(UnsubscribeRequestView);